import React, {Component} from 'react';
import { connect } from 'react-redux';

import * as actionTypes from '../../store/actions/actionTypes';
import classes from './GamesReference.module.css';
import Modal from "../../components/UI/Modal/Modal";
import GamesList from "../../components/GamesList/GamesList";
import GameDetails from "../../components/GameDetails/GameDetails";
import NewGame from "../../components/NewGame/NewGame";
import apiUrl from "../../shared/config";
import history from "../../history";
import GameSearchBar from "../../components/GameSearchBar/GameSearchBar";
import axios from "axios";

class GamesReference extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gameTypes: [],
            publishers: [],
            developers: [],
            gameStyles: [],
            users: [],
            gamesCount: 0, // lifted state so it can be used to display in game search
        };
    }


    componentDidMount() {
        if (this.props.match.params.gameId && ((this.props.selectedGame.id === null)
            || (this.props.selectedGame.id !== this.props.match.params.gameId))) {
            // If there's game id in the URL and either the selected game is null or the selected game doesn't have
            // the same id as the id in the URL, select the game with the id in the URL
            this.props.onSelectGame(this.props.match.params.gameId);
        }

        if (this.state.gameTypes.length === 0) {
            axios.get(apiUrl + 'GameTypes/getGameTypes')
                .then(response => {
                    this.setState({gameTypes: response.data});
                })
        }
        if (this.state.publishers.length === 0) {
            axios.get(apiUrl + 'Publishers/getPublishers')
                .then(response => {
                    this.setState({publishers: response.data});
                })
        }
        if (this.state.developers.length === 0) {
            axios.get(apiUrl + 'Developers/getDevelopers')
                .then(response => {
                    this.setState({developers: response.data});
                })
        }
        if (this.state.gameStyles.length === 0) {
            axios.get(apiUrl + 'Games/getGameStyles')
                .then(response => {
                    this.setState({gameStyles: response.data});
                })
        }
        if (this.state.users.length === 0) {
            axios.get(apiUrl + 'Users/getUsers')
                .then(response => {
                    this.setState({users: response.data});
                })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if(this.props.selectedGame.id === null) {
        //     this.props.onSelectGame(this.props.match.params.gameId);
        // }

        if (Number(prevProps.selectedGame.id) !== Number(this.props.selectedGame.id)) {
            if (this.props.selectedGame.id !== undefined && this.props.selectedGame.id !== null) {
                // In the case that there's been a change to the selected game and the selected game is
                // not null or undefined, add the new game's link to the browser history
                if (history.location.pathname !== '/PatternLibraryApp/GamesReference/' + this.props.selectedGame.id) {
                    // This if-statement prevents the same URL from being pushed to the history multiple times in a row
                    // console.log('push gr a', '/PatternLibraryApp/GamesReference/' + this.props.selectedGame.id)
                    history.push('/PatternLibraryApp/GamesReference/' + this.props.selectedGame.id);
                }
            } else {
                // In the case that there's been a change to the selected game and the selected game is null
                // or undefined, add the default link to the Games Reference to the browser's history
                if (history.location.pathname !== '/PatternLibraryApp/GamesReference/') {
                    // This if-statement prevents the same URL from being pushed to the history multiple times in a row
                    // console.log('push gr b', '/PatternLibraryApp/GamesReference/')
                    history.push('/PatternLibraryApp/GamesReference/')
                }
            }
        } else if (!this.props.match.params.gameId && this.props.selectedGame.id) {
            // In the case that there is no change in the selected game, but there's a selected game and no
            // game id in the URL, replace the link in history with one that goes directly to the selected game
            // console.log('push gr r', '/PatternLibraryApp/GamesReference/' + this.props.selectedGame.id)
            history.replace('/PatternLibraryApp/GamesReference/' + this.props.selectedGame.id);
        }
    }

    gameSelectedHandler = (id) => {
        this.props.onSelectGame(id);
    };

    patternSelectedHandler = (id) => {
        this.props.onSelectPattern(id);
    };

    gameAddHandler = () => {
        this.props.onAddGame();
    };

    gameCloseHandler = () => {
        this.props.onCloseGameDetails();
    };

    listReloadedHandler = () => {
        this.props.onListReloaded();
    };

    updateKeywordsFilterHandler = (keyword_ids) => {
        //console.log('Keywords Filter: ', keyword_ids);
        if(keyword_ids[0] === undefined) {
            keyword_ids = [];
        }
        this.props.onUpdateKeywordsFilter(keyword_ids);
    };

    updateGameStyleFilterHandler = (game_style_id) => {
        this.props.onUpdateGameStyleFilter(game_style_id);
    }

    reduceKeywordsArrayToFilter = (keywords_array) => {
        let keywords_filter = [];
        if (keywords_array !== null) {
            keywords_filter = keywords_array.map((keyword_object) => { return keyword_object.value});
        }
        //console.log('KEYWORDS FILTER', keywords_filter);
        this.updateKeywordsFilterHandler(keywords_filter);
    };

    gameNameFilterHandler = (new_value) => {
        this.props.onUpdateGameNameFilter(new_value);
    };
    gameDescriptionFilterHandler = (new_value) => {
        this.props.onUpdateGameDescriptionFilter(new_value);
    };

    gameTypesFilterHandler = (new_value) => {
        this.props.onUpdateGameTypesFilter(new_value);
    };

    gamePublishersFilterHandler = (new_value) => {
        this.props.onUpdateGamePublishersFilter(new_value);
    };

    gameDevelopersFilterHandler = (new_value) => {
        this.props.onUpdateGameDevelopersFilter(new_value);
    };

    releaseStartFilterHandler = (new_value) => {
        this.props.onUpdateReleaseStartFilter(new_value);
    };

    releaseEndFilterHandler = (new_value) => {
        this.props.onUpdateReleaseEndFilter(new_value);
    };

    updatePageHandler = (new_offset) => {
        this.props.onUpdatePagination(new_offset);
    };

    updateOrderByHandler = (new_order) => {
        this.props.onUpdateOrderBy(new_order);
    };

    newGameOpenHandler = (id) => {
        this.props.onNewGameOpen(id);
    };

    newGameCloseHandler = () => {
        this.props.onNewGameClosed();
    };

    toggleSearchHandler = () => {
        this.props.onToggleSearch();
    };

    updateGamesCount = (num) => {
        this.setState({gamesCount: num})
    }

    //TODO Swap this out with a game search bar
    gameSearchBar = (header_text) => (
        <GameSearchBar
            headerText={header_text}
            keywordsFilter={this.props.keywords_filter}
            updateKeywordsFilter={this.reduceKeywordsArrayToFilter}
            updateOrderBy={this.updateOrderByHandler}
            updatePage={this.updatePageHandler}
            closeGameDetails={this.gameCloseHandler}
            gameNameFilter={this.props.game_name_filter}
            updateGameNameFilter={this.gameNameFilterHandler}
            gameDescriptionFilter={this.props.game_description_filter}
            updateGameDescriptionFilter={this.gameDescriptionFilterHandler}
            gameTypesFilter={this.props.game_types_filter}
            updateGameTypesFilter={this.gameTypesFilterHandler}
            gamePublishersFilter={this.props.game_publishers_filter}
            updateGamePublishersFilter={this.gamePublishersFilterHandler}
            gameDevelopersFilter={this.props.game_developers_filter}
            updateGameDevelopersFilter={this.gameDevelopersFilterHandler}
            releaseStartFilter={this.props.release_start_filter}
            updateReleaseStartFilter={this.releaseStartFilterHandler}
            releaseEndFilter={this.props.release_end_filter}
            updateReleaseEndFilter={this.releaseEndFilterHandler}
            gameStyleFilter={this.props.game_style_filter}
            updateGameStyleFilter={this.updateGameStyleFilterHandler}
            toggleSearch={this.toggleSearchHandler}
            gameTypesArr={this.state.gameTypes}
            publishersArr={this.state.publishers}
            developersArr={this.state.developers}
            gameStylesArr={this.state.gameStyles}
            usersArr={this.state.users}
            gamesCount={this.state.gamesCount}
        />
    );

    welcomeModal = (modal_text) => (<section className={classes.Notice}>
        <div className={"card "+ classes.SearchFilterActiveNotice} onClick={this.toggleSearchHandler}>
            <h4 className={"card-header "+classes.NoticeHeader}>{modal_text}</h4>
        </div>
    </section>);

    isActivePatternSearch = () => ((this.props.game_name_filter !== null && this.props.game_name_filter.length > 0) ||
        (this.props.game_types_filter !== null && this.props.game_types_filter.length > 0) ||
        (this.props.game_developers_filter !== null && this.props.game_developers_filter.length > 0) ||
        (this.props.game_publishers_filter !== null && this.props.game_publishers_filter.length > 0) ||
        (this.props.release_start_filter) ||
        (this.props.release_end_filter))


    render () {
        return (
            <div>
                <header><h1 className={classes.PageTitle}>GAMES REFERENCE</h1></header>
                {!this.props.search_panel_active ? (this.isActivePatternSearch()
                        ? this.welcomeModal("Active Game Search")
                        : this.welcomeModal("Open Game Search"))
                    : ""}
                <section className={classes.GameSearchBar}>
                    {(this.props.search_panel_active
                        ? (this.isActivePatternSearch()
                            ? this.gameSearchBar("Active Game Search")
                            : this.gameSearchBar("Game Search"))
                        : "")}
                </section>
                <section className={classes.Games}>
                    <GamesList
                        gameSelected={this.gameSelectedHandler}
                        selectedGameId={this.props.selectedGame.id}
                        reloadList={this.props.reloadList}
                        listReloaded={this.listReloadedHandler}
                        newGame={this.newGameOpenHandler}
                        closeGameDetails={this.gameCloseHandler}
                        gameNameFilter={this.props.game_name_filter}
                        gameDescriptionFilter={this.props.game_description_filter}
                        gameTypesFilter={this.props.game_types_filter}
                        gamePublishersFilter={this.props.game_publishers_filter}
                        gameDevelopersFilter={this.props.game_developers_filter}
                        releaseStartFilter={this.props.release_start_filter}
                        releaseEndFilter={this.props.release_end_filter}
                        keywordsFilter={this.props.keywords_filter}
                        authorFilter={this.props.authors_filter}
                        gameStyleFilter={this.props.game_style_filter}
                        order_by={this.props.order_by}
                        gameList={this.props.gameList}
                        updatePage={this.updatePageHandler}
                        isAuthenticated={this.props.isAuthenticated}
                        updateCount={this.updateGamesCount}
                    />
                </section>

                <section id="game-details">
                    <GameDetails
                        id={this.props.selectedGame.id}
                        urlId={this.props.match.params.gameId}
                        gameDetailsOpen={this.props.gameDetailsOpen}
                        closeGameDetails={this.gameCloseHandler}
                        patternSelected={this.patternSelectedHandler}
                        gameSelected={this.gameSelectedHandler}
                        listReloaded={this.listReloadedHandler}
                        updateKeywordsFilter={this.updateKeywordsFilterHandler}
                        updatePage={this.updatePageHandler}
                        editGame={this.newGameOpenHandler}
                        isAuthenticated={this.props.isAuthenticated}
                        userId={this.props.userId}
                        authenticationLevel={this.props.authenticationLevel}
                        token={this.props.token}
                        permissions={this.props.permissions}
                    />
                </section>
                <section>
                    <Modal show={this.props.new_game_open} modalClosed={this.newGameCloseHandler}>
                        <NewGame
                            token={this.props.token}
                            selectedGameId={this.props.selectedGame.id}
                            addGame={this.gameAddHandler}
                            cancelAddGame={this.newGameCloseHandler}
                            newGameOpen={this.props.new_game_open}
                            updatePage={this.updatePageHandler}
                            closeGameDetails={this.gameCloseHandler}
                            userId={this.props.userId}
                            isAuthenticated={this.props.isAuthenticated}
                            authenticationLevel={this.props.authenticationLevel}
                        />
                    </Modal>
                </section>
                <section>
                    <div className={classes.dragon}><img src={apiUrl +"Images/Dragon-rotated.png"} width="200px" alt="Pattern Dragon"/></div>
                </section>
        </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedGame: {
            id: state.gamesReference.selectedGame.id
        },
        gameList: {
            offset: state.gamesReference.gameList.offset,
            quantity: state.gamesReference.gameList.quantity
        },
        reloadList: state.gamesReference.reloadList,
        game_name_filter: state.gamesReference.game_name_filter,
        game_description_filter: state.gamesReference.game_description_filter,
        game_types_filter: state.gamesReference.game_types_filter,
        game_publishers_filter: state.gamesReference.game_publishers_filter,
        game_developers_filter: state.gamesReference.game_developers_filter,
        release_start_filter: state.gamesReference.release_start_filter,
        release_end_filter: state.gamesReference.release_end_filter,
        keywords_filter: state.gamesReference.keywords_filter,
        authors_filter: state.gamesReference.authors_filter,
        game_style_filter: state.gamesReference.game_style_filter,
        order_by: state.gamesReference.order_by,
        new_game_open: state.gamesReference.new_game_open,
        gameDetailsOpen: state.gamesReference.gameDetailsOpen,
        games: state.gamesReference.games,
        search_panel_active: state.gamesReference.search_panel_active,
        isAuthenticated: state.auth.token !== null,
        userId: state.auth.userId,
        authenticationLevel: state.auth.authLevel,
        token: state.auth.token,
        permissions: state.auth.userPermissions
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onSelectPattern: (selectedPatternId) => dispatch({ type: actionTypes.SELECT_PATTERN, selectedPatternId: selectedPatternId}),
        onSelectGame: (selectedGameId) => dispatch({ type: actionTypes.SELECT_GAME, selectedGameId: selectedGameId}),
        onAddGame: () => dispatch({ type: actionTypes.ADD_GAME}),
        onEditGame: () => dispatch({ type: actionTypes.EDIT_GAME}),
        onNewGameOpen: (selectedGameId) => dispatch({ type: actionTypes.NEW_GAME_OPEN, selectedGameId: selectedGameId}),
        onNewGameClosed: () => dispatch({ type: actionTypes.NEW_GAME_CLOSED}),
        onCloseGameDetails: (selectedGameId) => dispatch({ type: actionTypes.CLOSE_GAME_DETAILS, selectedGameId: selectedGameId}),
        onUpdateGameNameFilter: (name_filter) => dispatch({ type: actionTypes.UPDATE_GAME_NAME_FILTER, game_name_filter: name_filter}),
        onUpdateGameDescriptionFilter: (description_filter) => dispatch({ type: actionTypes.UPDATE_GAME_DESCRIPTION_FILTER, game_description_filter: description_filter}),
        onUpdateGameTypesFilter: (type_ids) => dispatch({ type: actionTypes.UPDATE_GAME_TYPES_FILTER, game_types_filter: type_ids}),
        onUpdateGamePublishersFilter: (publisher_ids) => dispatch({ type: actionTypes.UPDATE_GAME_PUBLISHERS_FILTER, game_publishers_filter: publisher_ids}),
        onUpdateGameDevelopersFilter: (developer_ids) => dispatch({ type: actionTypes.UPDATE_GAME_DEVELOPERS_FILTER, game_developers_filter: developer_ids}),
        onUpdateReleaseStartFilter: (release_start_filter) => dispatch({ type: actionTypes.UPDATE_RELEASE_START_FILTER, release_start_filter: release_start_filter}),
        onUpdateReleaseEndFilter: (release_end_filter) => dispatch({ type: actionTypes.UPDATE_RELEASE_END_FILTER, release_end_filter: release_end_filter}),
        onUpdateKeywordsFilter: (keyword_ids) => dispatch({ type: actionTypes.UPDATE_GAMES_KEYWORDS_FILTER, keywords_filter: keyword_ids}),
        onUpdateGameStyleFilter: (game_style_id) => dispatch({type: actionTypes.UPDATE_GAMES_GAMES_STYLE_FILTER, game_style_id: game_style_id}),
        onUpdatePagination: (offset) => dispatch({ type: actionTypes.UPDATE_GAMES_PAGINATION, offset: offset}),
        onUpdateOrderBy: (order_by) => dispatch({ type: actionTypes.UPDATE_GAMES_ORDER_BY, order_by: order_by}),
        onListReloaded: () => dispatch({ type: actionTypes.LIST_RELOADED}),
        onToggleSearch: () => dispatch({ type: actionTypes.SEARCH_GAMES_TOGGLE})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GamesReference);